module.exports = __webpack_public_path__ + "img/NL370.30a6485a.png";